import {FlexLayoutItemConfig} from './flex-layout-item.config';
import {FlexLayoutFieldConfig} from './flex-layout-field.config';

export class FlexLayoutConfig {
    name: string;
    fields: FlexLayoutFieldConfig[];
    colsCount?: number;
    rowsCount?: number;
    cols?: FlexLayoutItemConfig[];
    rows?: FlexLayoutItemConfig[];
}
